var React = require('react');

function ArrowTop (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M6.98657 3.71547L3.98657 0.732422L0.986572 3.71547","stroke":"white","strokeWidth":"0.5","strokeMiterlimit":"10","key":0}),React.createElement("path",{"d":"M3.98657 0.732422V8.73242","stroke":"white","strokeWidth":"0.5","strokeMiterlimit":"10","key":1})]);
}

ArrowTop.defaultProps = {"width":"8","height":"9","viewBox":"0 0 8 9","fill":"none"};

module.exports = ArrowTop;

ArrowTop.default = ArrowTop;
